import {
    type SlateEditor,
} from '@udecode/plate';

import { BaseCitationPlugin } from '../BaseCitationPlugin';
import type { TCitationElement } from '../types';

export type UpdateCitationOptions = {
    pageNumber: string;
};

export const updateCitation = (
    editor: SlateEditor,
    {
        pageNumber
    }: UpdateCitationOptions
) => {
    const at = editor.selection;

    if (!at){
        return;
    }

    const [ currentElement, path ] = editor.api.node<TCitationElement>({
        at,
        match: { type: editor.getType(BaseCitationPlugin) },
    }) ?? [];

    if (!currentElement || !path) {
        return;
    }

    editor.tf.withoutNormalizing(() => {
        editor.tf.setNodes<TCitationElement>(
            {
                ...currentElement,
                pageNumber: pageNumber
            },
            {
                at: path,
            }
        );
    });
};
